import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as InformationIcon } from 'assets/icon-information.svg';
import { ButtonIcon } from 'shared/components/Buttons';
import { Input, Span } from './styles';

const RadioButton = ({ option, selectedOption, onClick, tooltipLabel, disabled }) => {
  return (
    <>
      <Input
        type="radio"
        onClick={() => onClick(option.value)}
        value={option.value}
        checked={option.value === selectedOption}
        onChange={() => null}
        disabled={disabled}
      />
      <Span className="ml-2 text-nowrap">{option.name}</Span>
      {tooltipLabel && (
        <ButtonIcon
          title={tooltipLabel}
          id={`radio-option-help-${option.value}`}
          className="button-icon"
          Icon={() => <InformationIcon fill="current" />}
        />
      )}
    </>
  );
};

RadioButton.defaultProps = {
  selectedOption: null,
  tooltipLabel: '',
  disabled: false,
};

RadioButton.propTypes = {
  option: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }).isRequired,
  selectedOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func.isRequired,
  tooltipLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

export default RadioButton;
